/**
 * Lot-size quantity rules for storefront (mirrors API/utils/lotSize.js).
 */

export function getEffectiveLotSize(storeLotSizeEnabled, productLotSize) {
  if (!storeLotSizeEnabled || !productLotSize?.isEnabled) return null;
  const base = Number(productLotSize.baseQuantity);
  const multiple = Number(productLotSize.quantityMultiple);
  if (!Number.isInteger(base) || base < 1 || !Number.isInteger(multiple) || multiple < 1) {
    return null;
  }
  return { baseQuantity: base, quantityMultiple: multiple };
}

export function isValidLotQuantity(qty, lotSize) {
  if (!lotSize) return true;
  const q = Number(qty);
  if (!Number.isInteger(q) || q < lotSize.baseQuantity) return false;
  return (q - lotSize.baseQuantity) % lotSize.quantityMultiple === 0;
}

export function getInitialLotQuantity(lotSize) {
  return lotSize ? lotSize.baseQuantity : 1;
}

export function stepLotQuantity(currentQty, lotSize, direction) {
  if (!lotSize) {
    const next = (Number(currentQty) || 1) + direction;
    return Math.max(1, next);
  }
  const { baseQuantity: base, quantityMultiple: step } = lotSize;
  const current = Number(currentQty) || base;
  if (direction > 0) {
    if (current < base) return base;
    return current + step;
  }
  if (current <= base) return base;
  const next = current - step;
  return next < base ? base : next;
}

export function snapToValidLotQuantity(qty, lotSize) {
  if (!lotSize) return Math.max(1, Math.floor(Number(qty)) || 1);
  const { baseQuantity: base, quantityMultiple: step } = lotSize;
  let q = Math.floor(Number(qty));
  if (!Number.isFinite(q) || q < base) return base;
  const rem = (q - base) % step;
  if (rem === 0) return q;
  return q + (step - rem);
}

export function formatLotSizeHint(lotSize) {
  if (!lotSize) return '';
  const { baseQuantity: base, quantityMultiple: step } = lotSize;
  const ex2 = base + step;
  const ex3 = base + 2 * step;
  return `Minimum order: ${base}. Order in multiples of ${step} (e.g. ${base}, ${ex2}, ${ex3}).`;
}

export function getLotQuantityError(qty, lotSize, productName = 'This product') {
  if (!lotSize || isValidLotQuantity(qty, lotSize)) return null;
  const { baseQuantity: base, quantityMultiple: step } = lotSize;
  const ex2 = base + step;
  return `${productName}: order ${base}, ${ex2}, or higher in steps of ${step}.`;
}

export function resolveCartItemLotSize(item) {
  if (!item?.lotSize?.baseQuantity || !item?.lotSize?.quantityMultiple) return null;
  return {
    baseQuantity: item.lotSize.baseQuantity,
    quantityMultiple: item.lotSize.quantityMultiple,
  };
}
